import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    SuccessFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { useNavigate, useLocation } from 'react-router-dom';
import ContactInfoVerificationStep1 from '../../../../Escalation/Otp/contactInfoVerification/contactInfoVerificationStep1';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';

export interface FeedbackChangeDataInterface {
    fromDesktop?: boolean;
    setComponentSelected?: any;
    fromOnboardingDesktop?: any;
    typeVerificationDesktop?: any;
    errDesktop?: any;
    stateFeedbackDesktop?: any;
}

export const FeedbackChangeData: React.FC<FeedbackChangeDataInterface> = ({
    fromDesktop,
    setComponentSelected,
    fromOnboardingDesktop,
    typeVerificationDesktop,
    errDesktop,
    stateFeedbackDesktop,
}: FeedbackChangeDataInterface) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { state } = useLocation();
    const { trackingScreenView } = new TrackingEvents();
    const size = useWindowSize();
    const feedbackState = fromDesktop ? stateFeedbackDesktop : state?.stateFeedback;
    const error = fromDesktop ? errDesktop : state?.err;
    const type = fromDesktop ? typeVerificationDesktop : state?.typeVerification;

    const sendToNative = (url: string) => {
        if (fromDesktop) {
            if (fromOnboardingDesktop === 'true') {
                setComponentSelected(
                    <ContactInfoVerificationStep1
                        fromDesktop={true}
                        setComponentSelected={setComponentSelected}
                    ></ContactInfoVerificationStep1>,
                );
            }
        } else {
            if (state?.fromOnboarding === 'true') {
                navigate(url);
            } else {
                navigate(url);
            }
        }
    };

    const urlRedirect: any = () => {
        if (fromDesktop) {
            if (fromOnboardingDesktop === 'true') {
                return '/obd/verify/contacts';
            } else {
                return '/profile';
            }
        } else {
            if (state?.fromOnboarding === 'true') {
                return '/obd/verify/contacts';
            } else {
                return '/profile';
            }
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='feedbackChangeData-page'
            style={{
                background:
                    feedbackState === 'SUCCESS'
                        ? size.width < 1024 || size.height < 550
                            ? skinVars.colors.backgroundBrand
                            : ''
                        : skinVars.colors.background,
            }}
        >
            {feedbackState === 'SUCCESS' ? (
                <SuccessFeedbackScreen
                    title={
                        type === 'mobile'
                            ? t('profileChangeMobileFeedbackSuccessTitle')
                            : t('profileChangeEmailFeedbackSuccessTitle')
                    }
                    description={
                        type === 'mobile'
                            ? t('profileChangeMobileFeedbackSuccessSubtitle')
                            : t('profileChangeEmailFeedbackSuccessSubtitle')
                    }
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative(urlRedirect());
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></SuccessFeedbackScreen>
            ) : (
                <ErrorFeedbackScreen
                    title={error?.title}
                    description={error?.localizedDescription}
                    errorReference={'Código de error: ' + `${error?.id}`}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative(urlRedirect());
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></ErrorFeedbackScreen>
            )}
        </div>
    );
};

export default FeedbackChangeData;
